import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Phone, MapPin, Linkedin, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="32241" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-5 w-24 bg-white/10 animate-pulse rounded" data-index={i} />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-[#A9A9A9] hover:text-[#2EA3D2] transition-colors duration-300 font-sans font-normal tracking-tight text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const phoneNumber = "+1 (800) 555-0199";
  const whatsappUrl = "https://wa.me/18005550199";
  return <footer id="footer" className="dark bg-[#04052F] text-[#FFFFFF] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/HomePage" className="block">
              <span className="text-2xl font-bold tracking-tighter text-[#FFFFFF]">Alliloop</span>
            </Link>
            <div className="space-y-4 max-w-xs">
              <p className="text-[#A9A9A9] font-sans font-normal leading-relaxed text-sm">
                The Caregiving Workforce Platform that Puts People First. Alliloop builds bridges across the care economy.
              </p>
              <div className="flex items-start gap-3 text-[#A9A9A9]">
                <MapPin className="w-5 h-5 text-[#2EA3D2] shrink-0 mt-0.5" />
                <span className="font-sans font-normal text-sm">
                  Global Workforce Solutions & Care Support
                </span>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-sans text-xl text-[#FFFFFF] font-bold tracking-tight"><br /></h3>
            <MenuProvider menu_id="footer_menu" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-sans text-xl text-[#FFFFFF] font-bold tracking-tight">
              Contact Us
            </h3>
            <div className="space-y-4">
              <Link to="#" className="flex items-center gap-3 text-[#A9A9A9] hover:text-[#2EA3D2] transition-colors duration-300 group w-fit">
                <Mail className="w-5 h-5 text-[#2EA3D2] group-hover:text-[#2EA3D2]/80" />
                <span className="font-sans font-normal tracking-tight">Contact Form</span>
              </Link>
              
              <Button asChild variant="outline" className="w-full sm:w-auto justify-start gap-3 border-white/10 bg-[#090834] hover:bg-[#090834]/80 text-[#FFFFFF] hover:text-[#2EA3D2] hover:border-[#2EA3D2]/50 transition-all duration-300 rounded-lg">
                <Link to={whatsappUrl} newTab>
                </Link>
              </Button>
            </div>

            <div className="pt-4">
              <h4 className="text-sm font-sans font-semibold text-[#FFFFFF]/80 mb-4 uppercase tracking-widest">Follow Us</h4>
              <div className="flex gap-4">
                {[{
                icon: Linkedin,
                label: "LinkedIn",
                href: "#"
              }].map((social, i) => <Link key={i} to={social.href} className="p-2 rounded-lg bg-[#090834] border border-white/10 text-[#A9A9A9] hover:text-[#2EA3D2] hover:border-[#2EA3D2]/50 hover:bg-[#2EA3D2]/10 transition-all duration-300 flex items-center justify-center" aria-label={social.label} data-index={i}>
                    <social.icon className="w-5 h-5" />
                  </Link>)}
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] uppercase tracking-widest text-[#A9A9A9]/60 font-sans">
          <p>
            &copy; {currentYear} Alliloop. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-[#2EA3D2] transition-colors">Terms of Use</Link>
            <Link to="#" className="hover:text-[#2EA3D2] transition-colors">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>;
}